import React from 'react';
import { motion } from 'framer-motion';
export function Bonos() {
  const bonos = [{
    num: '01',
    title: 'Kit de Emergencia Anti-Hinchazón 24 Horas',
    desc: 'Deshinchate rápido antes de una salida o después de un exceso. Protocolo hora por hora.',
    price: '$9.900'
  }, {
    num: '02',
    title: 'Menú Express de 3 Días para Desinflamar',
    desc: '3 días de comidas simples y anti-inflamatorias con ingredientes del chino del barrio.',
    price: '$8.900'
  }, {
    num: '03',
    title: 'Checklist de Supermercado Anti-Panza',
    desc: 'Lista verde, lista roja y 30+ sustituciones. Entrá al súper sin dudar.',
    price: '$7.900'
  }, {
    num: '04',
    title: 'Recetas Express de 5 Minutos',
    desc: '16 recetas rápidas para no romper el plan cuando no hay tiempo ni energía.',
    price: '$8.900'
  }, {
    num: '05',
    title: 'Rutina Matinal Abdomen Plano en 7 Minutos',
    desc: 'La secuencia de mañana para arrancar el día menos inflamado/a desde el primer minuto.',
    price: '$9.900'
  }, {
    num: '06',
    title: 'Plan Anti-Sabotaje para Fines de Semana',
    desc: 'Protocolo del viernes, sábado y domingo. Llegá al lunes sin sentir que arruinaste todo.',
    price: '$8.900'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-35" data-mp="2zgfue8j0yvib">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-16" data-id="element-36" data-mp="y0srouyy0rg">
        <h2 className="text-4xl md:text-5xl font-black leading-tight" data-id="element-37" data-mp="3n6sa45kihwjg">
          🎁 6 BONOS INCLUIDOS
          <br data-id="element-38" data-mp="3i7yxefd1u9kc" />
          <span className="text-brand-gold" data-id="element-39" data-mp="2bpaho28dsjc8">SIEMPRE GRATIS</span>
        </h2>
      </motion.div>

      <div className="space-y-4 mb-12" data-id="element-40" data-mp="26qfpwasfrkfz">
        {bonos.map((bono, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-brand-card border border-brand-gold/20 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-41" data-mp="26sk4pnrvi3v1" data-mpi={i}>
            <div className="text-5xl font-black text-brand-gold/20 shrink-0" data-id="element-42" data-mp="jtpy13cizmhl">
              {bono.num}
            </div>
            <div className="flex-grow" data-id="element-43" data-mp="62uwyd89q9ok">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-44" data-mp="63wb4qkkzcai">
                {bono.title}
              </h3>
              <p className="text-gray-400" data-id="element-45" data-mp="b1o3flp510f8">{bono.desc}</p>
            </div>
            <div className="shrink-0 text-right md:text-center mt-4 md:mt-0 bg-brand-darker/50 p-4 rounded-xl border border-brand-green/10" data-id="element-46" data-mp="3saugrdknlxnn">
              <div className="text-gray-500 line-through text-sm mb-1" data-id="element-47" data-mp="152u4o63535l">
                {bono.price}
              </div>
              <div className="text-brand-green font-black text-xl" data-id="element-48" data-mp="39liqzf9dq7m6">GRATIS</div>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-brand-green text-white font-black text-xl md:text-2xl p-6 rounded-2xl text-center shadow-[0_0_30px_rgba(168,85,247,0.2)]" data-id="element-49" data-mp="3nmld1s0djhx3">
        Valor total bonos:{' '}
        <span className="line-through opacity-70" data-id="element-50" data-mp="a4suc6m1hfko">$54.400</span> → GRATIS con tu
        SuperPack
      </motion.div>
    </section>;
}